export const MODULES = {
  PAYMENTS: 1,
  PAYMENT_PLAN: 2,
  AR_AUTOMATION: 3,
  PRACTICE_ANALYTICS: 4,
  MORNING_HUDDLE: 5,
  PRACTICE_ASSESSMENT: 6,
  PRACTICE_EVALUATION: 7,
  PRACTICE: 8,  // Used in Practice Agreement Payment
};

export const PAYMENT_RELATED_MODULES_DROPDOWN = {
  1: 'Payments',
  2: 'Payment Plan',
  3: 'A/R Automation',
  4: 'Pay Now',
};
